import * as types from "./record.actions";

const initialState = {
  periodId: undefined,
  recordId: undefined,
  deletedDocumentation: [],
  review: {},
  entities: {
    patients: {},
    documentation: {},
    periods: {},  
  }
};

export default function (state = initialState, action) {

  let record;
  let newRecord;

  switch (action.type) {

    case types.REVIEW_RETRIEVED:
      console.log('REVIEW_RETRIEVED action payload', action.payload)
      return {
        ...state,
        fetching: false,
        review: {...action.payload}     
      };

    case types.RECORD_CLEARED:
      return {...initialState};

    case types.RECORD_RETRIEVED:
      return {
        ...state,
        fetching: false,
        periodId: action.payload.periodId,
        recordId: action.payload.result,
        entities: {
          ...state.entities,
          ...action.payload.entities
        }
      };

    case types.DOCUMENTATION_UPLOADED:
      console.log('DOCUMENTATION_UPLOADED action payload', action.payload)
      const upload = action.payload.entities.documentation[action.payload.result];
      const {recordStatus, recordStatusValue, user: lastSavedBy, timestamp: statusDate} = upload;

      const afterDocumentUploadedState = {
        ...state,
        entities: {
          ...state.entities,
          documentation: {
            ...action.payload.entities.documentation,
            ...state.entities.documentation,
          },
          patients: {
            ...state.entities.patients,
            [upload.recordId]: {
              ...state.entities.patients[upload.recordId],
              ...{recordStatus, recordStatusValue, lastSavedBy, statusDate}
            }
          }
        }
      };
      return updateFacilityStatus(afterDocumentUploadedState, upload.periodId, action.payload.userFacilityId, 'In Progress');

    case types.RECORD_SAVED:
      console.log('RECORD_SAVED payload', action.payload)
      const recordSavedPayload = Array.isArray(action.payload) ? action.payload[0] : action.payload;
      return updateFacilityStatus(updateRecord(state, recordSavedPayload), recordSavedPayload.periodId, recordSavedPayload.facilityId, 'Complete');
      

    case types.RECORD_UPDATED:
      return {
        ...state,
        entities: {
          ...state.entities,
          patients: {
            ...state.entities.patients,
            [action.payload.result]: {
              ...state.entities.patients[action.payload.result],
              ...action.payload.entities.patients[action.payload.result]
            }
          }
        }
      };

    case types.DOCUMENTATION_DELETED:
      return {
        ...state,
        deletedDocumentation: [...state.deletedDocumentation, action.payload]
      };

    case types.ATTENDING_PHYSICIAN_SAVED:
      
      record = state.entities.patients[action.payload.recordId];    
      newRecord = {...record, attendingPhysician: action.payload.attendingPhysician};

      return {
        ...state,
        entities: {
          ...state.entities,
          patients: {
            ...state.entities.patients,
            [action.payload.recordId]: newRecord
          }
        }
      };

    case types.RECORD_STATUS_CHANGED:
      debugger
      const recordStatusChangedEvent = action.payload.find(p => p.type === 'RecordStatusChanged');

      record = state.entities.patients[recordStatusChangedEvent.recordId];
      newRecord = {...record, recordStatus: recordStatusChangedEvent.recordStatus, recordStatusValue: recordStatusChangedEvent.recordStatusValue};

      return {
        ...state,
        entities: {
          ...state.entities,
          patients: {
            ...state.entities.patients,
            [recordStatusChangedEvent.recordId]: newRecord
          },
          periods: {
            ...state.entities.periods,
            [recordStatusChangedEvent.periodId]: {...state.entities.periods[recordStatusChangedEvent.periodId], quarterlyStatus: 'In Progress'}
          }
        }
      };

    default:
      return state;
  }
}

function updateRecord(state, {recordId, recordStatus, recordStatusValue, timestamp, user, quarterlyStatus, periodId}) {
  const record = state.entities.patients[recordId];
  const newRecord = {...record, 
    recordStatus, 
    recordStatusValue, 
    lastSavedBy: user, 
    statusDate: timestamp
    };

  return {
    ...state,
    entities: {
      ...state.entities,
      patients: {
        ...state.entities.patients,
        [recordId]: newRecord
      },
      periods: {
        ...state.entities.periods,
        [periodId]: {...state.entities.periods[periodId], quarterlyStatus}
      }
    }
  };
  
}


function updateFacilityStatus (state, periodId, facilityId, newStatus)  {
  if (state.entities.periods[periodId]) { 
    return {...state, 
      entities: {
        ...state.entities,
        periods: {
          ...state.entities.periods,
          [periodId]: {
            ...state.entities.periods[periodId],
            ...{facilityStatuses: state.entities.periods[periodId].facilityStatuses ? state.entities.periods[periodId].facilityStatuses
              .map(fs => (fs.nursingFacilityId === facilityId && fs.periodId === periodId) 
                ? {...fs, status: newStatus} 
                : fs ) : []
            }
          }
        }
      }
    };
  } else {
    return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/record/record.reducer.js